import help from './help';

export default help;



// WEBPACK FOOTER //
// ./src/pages/static/help/index.jsx